import { PropsWithChildren } from 'react';

import { QueryErrorResetBoundary } from '@tanstack/react-query';

import { ErrorBoundary } from 'react-error-boundary';

import { logger } from '@/shared/lib';
import { ErrorFallback } from '@/widgets/ErrorFallback';

const ErrorBoundaryProvider = ({ children }: PropsWithChildren) => {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          onError={(error, info) => {
            logger.error(error, {
              componentStack: info.componentStack,
            });
          }}
          fallbackRender={({ resetErrorBoundary }) => (
            <ErrorFallback onTryAgain={resetErrorBoundary} />
          )}
        >
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
};

export default ErrorBoundaryProvider;
